import {
  FIELD_BIRTH,
  FIELD_EMAIL,
  FIELD_FIRST_NAME,
  FIELD_GENDER,
  FIELD_LAST_NAME,
  FIELD_NATIONALITY,
  FIELD_PHONE,
} from '@components/dynamic-input-fields/src/utils';
import { FormField } from '@components/modals/add-holder-modal/src/add-holder-modal.type';
import {
  emailValidator,
  isNumberAndNotIncludesPlus,
  numberEndsWithPlus,
  numberStartsWithPlus,
  textValidator,
} from '@utils/validations/text-validators';

import { InviteGuestForm } from '../src/process-invite-guest.type';

const createField = (field: keyof InviteGuestForm, form: InviteGuestForm) => {
  return {
    name: field,
    value: form[field],
  };
};
export const createFieldsFromBookingFormFields = (form: InviteGuestForm) => {
  const fields = [];
  if (!!form.firstName) fields.push(createField(FIELD_FIRST_NAME, form));
  if (!!form.lastName) fields.push(createField(FIELD_LAST_NAME, form));
  if (!!form.email) fields.push(createField(FIELD_EMAIL, form));
  if (!!form.phone) fields.push(createField(FIELD_PHONE, form));
  if (!!form.gender) fields.push(createField(FIELD_GENDER, form));
  if (!!form.nationality) fields.push(createField(FIELD_NATIONALITY, form));
  if (!!form.birth) fields.push(createField(FIELD_BIRTH, form));

  return fields as FormField[];
};

export const createMultiInviteTextRows = (
  text: string
): { row: number; fullName: string; numTickets: string | 1; email: string | null }[] => {
  const lines: string[] = text.trim().split('\n');
  return lines.map((line: string, index) => {
    const parts: string[] = line.trim().split(/\s+/);
    let nameSurname: string = '';
    let quantity: number | null = null;
    let email: string | null = null;

    parts.forEach((part) => {
      if (emailValidator.test(part)) {
        email = part;
      } else if (isNumberAndNotIncludesPlus(part)) {
        quantity = parseInt(part);
      } else if (numberEndsWithPlus(part)) {
        quantity = parseInt(part.substring(0), 10) + 1;
      } else if (numberStartsWithPlus(part)) {
        quantity = parseInt(part.substring(1), 10) + 1;
      } else if (textValidator.test(part)) {
        nameSurname += `${part} `;
      }
    });

    return {
      row: index + 1,
      fullName: nameSurname.trim(),
      numTickets: quantity ?? 1,
      email,
    };
  });
};

export { createMultiInviteTextRows as createBulkProcessTextRows };
